<template>
  <div class="card mb-5">
    <div class="card-body py-5">
      <p class="text-center text-muted mb-0">{{message}}</p>
    </div>
  </div>
</template>


<script charset="utf-8">
export default {
  name: "Error",
  props: [ 'message' ]
}
</script>
